import { render } from "./InitiativeDetails.vue?vue&type=template&id=09648e62"
import script from "./InitiativeDetails.vue?vue&type=script&lang=js"
export * from "./InitiativeDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/results/InitiativeDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09648e62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09648e62', __exports__)) {
    api.reload('09648e62', __exports__)
  }
  
  module.hot.accept("./InitiativeDetails.vue?vue&type=template&id=09648e62", () => {
    api.rerender('09648e62', render)
  })

}


export default __exports__